import PanelBox from '../../components/PanelBox';
import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import { connect } from "react-redux";
import { Card, Table, Form, Input, Tooltip, Icon, Cascader, Select, Row, Col, Checkbox, Button, Upload, notification } from 'antd';

import ct from '../../assets/svgicons/DeepCBCT_analysis.svg';
import ct_align from '../../assets/svgicons/DeepCBCT_analysis.svg';
import ct_v2 from '../../assets/svgicons/DeepCBCT_analysis.svg';
import ct_v2_auto from '../../assets/svgicons/DeepCBCT_analysis_auto.svg';
import plan_standart from '../../assets/svgicons/3d-plan_general OrthoStudio V4.svg';
import plan_roots from '../../assets/svgicons/3d-plan_roots.svg';
import plan_deep_ct from '../../assets/svgicons/3d-plan_DeepCBCT.svg';
import plan_standard_orthostudio from '../../assets/svgicons/3d-plan_general.svg';
import plan_standard_3shape_1c from '../../assets/svgicons/3d-plan_general_3Shape.svg';
import plan_standard_3shape_color from '../../assets/svgicons/3d-plan_general_3Shape_Color.svg';
import plan_standard_archform_1c from '../../assets/svgicons/3d-plan_general_Archform.svg';
import plan_standard_onyxceph from '../../assets/svgicons/3d-plan_general_OnyxCeph3D.svg';
import plan_standard_suresmile_sou from '../../assets/svgicons/3d-plan_general SureSmile.svg';
import plan_standard_orthostudio_v5 from '../../assets/svgicons/3d-plan_general OrthoStudio V5.svg';
import teeth_alignment_modelling from '../../assets/svgicons/Teeth_alignment_modelling.svg';
import teeth_alignment_modelling2 from '../../assets/svgicons/Teeth_alignment_modelling_ace.svg';
import teeth_alignment_modelling_external from '../../assets/svgicons/Teeth_alignment_modelling_external.svg';
import roots_alignment_modelling from '../../assets/svgicons/Roots_alignment_modelling.svg';
import roots_alignment_modelling_external from '../../assets/svgicons/Roots_alignment_modelling_external.svg';
import plan_standard_nemo from '../../assets/svgicons/3d-plan_general_Nemo.svg';
import ram_single_control_point from '../../assets/svgicons/RAM_Single_Control_Point.svg';

const svgDict = {
  ct, ct_align, ct_v2, ct_v2_auto,
  plan_standart, plan_standard_orthostudio, plan_standard_3shape_1c, plan_standard_3shape_color,
  plan_standard_archform_1c, plan_roots, plan_deep_ct, plan_standard_onyxceph, plan_standard_orthostudio_v5,
  plan_standard_suresmile_sou, teeth_alignment_modelling, teeth_alignment_modelling2, teeth_alignment_modelling_external,
  roots_alignment_modelling, roots_alignment_modelling_external, plan_standard_nemo,
  ram_single_control_point
};

const Dragger = Upload.Dragger;

const typeDict = {
  ct: 'DeepCBCT',
  ct_align: 'DeepCBCT (Smartee)',
  ct_v2: 'DeepCBCT v2',
  ct_v2_auto: 'DeepCBCT v2 Auto',
  plan_standart: '3D-Plan Standard',
  plan_roots: '3D-Plan Roots',
  plan_deep_ct: '3D-Plan DeepCT',
  plan_standard_orthostudio: '3D-Plan Orthostudio',
  plan_standard_3shape_1c: '3D-Plan 3Shape',
  plan_standard_3shape_color: '3D-Plan 3Shape Color',
  plan_standard_archform_1c: '3D-Plan Archform',
  plan_standard_onyxceph: '3D-Plan OnyxCeph',
  plan_standard_orthostudio_v5:'3D-Plan Orthostudio v5',
  plan_standard_suresmile_sou: '3D-Plan SureSmile SOU',
  plan_standard_nemo: '3D-Plan Nemo',
  teeth_alignment_modelling: 'Teeth alignment modelling',
  teeth_alignment_modelling2: 'Ace Aligners modelling',
  teeth_alignment_modelling_external: 'Teeth alignment modelling \n External',
  roots_alignment_modelling: 'Roots alignment modelling',
  roots_alignment_modelling_external: 'Roots alignment modelling \n External',
  ram_single_control_point: 'RAM Single Control Point'
};


class CaseNew extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }


  render() {
    return (
      <PanelBox title={"New case"}>
        <Row type="flex" justify="spaceAround">
          <Col span={24}>
            <Row type="flex" justify="center">
                {this.props.user.flow.map((elm) => (
                  <Link
                    key={elm.type}
                    id={elm.type.replace(/\_/g, '-')}
                    to={`case/upload/${elm.type.replace(/\_/g, '-')}`}
                    className="ant-upload-text"
                    style={{margin: 10, color: '#4a4a4a', whiteSpace: 'break-spaces'}}
                  >
                    <Card noHovering={false} style={{borderRadius: 200}}>
                      <img
                        src={svgDict[elm.type]}
                        style={{width: '100px'}}
                      />
                    </Card>
                    {typeDict[elm.type]}
                  </Link>
                )
              )}
            </Row>
          </Col>
          <Col span={24}>
           {/*
            <Row type="flex" justify="center">
              <Link
                to={'case/upload'}
                style={{margin: 10}}
              >
                <Card noHovering={false}>
                  <Icon type="info-circle" /> Status
                </Card>
              </Link>
            </Row>*/}
          </Col>
        </Row>
      </PanelBox>
    );
  }
}

export default connect(({ user }) => ({ user }))(CaseNew);



// WEBPACK FOOTER //
// ./src/views/Cases/caseNew.jsx